import type {
  MultipleAvailableOpportunity,
  MultipleOpportunity,
  SingleAvailableOpportunity,
  SingleOpportunity
} from '@swf/generated/types/api/sports';

import {
  getIsAvailableOpportunity,
  getIsMultipleOpportunity,
  getIsSingleOpportunity
} from './getIsOpportunity';

export const getAvailableSingleOpportunities = (
  opportunities: (SingleOpportunity | MultipleOpportunity)[]
): SingleAvailableOpportunity[] =>
  opportunities.filter(
    (opportunity: SingleOpportunity | MultipleOpportunity) =>
      getIsSingleOpportunity(opportunity) && getIsAvailableOpportunity(opportunity)
  ) as SingleAvailableOpportunity[];

export const getAvailableMultipleOpportunities = (
  opportunities: (SingleOpportunity | MultipleOpportunity)[]
): MultipleAvailableOpportunity[] =>
  opportunities.filter(
    (opportunity: SingleOpportunity | MultipleOpportunity) =>
      getIsMultipleOpportunity(opportunity) && getIsAvailableOpportunity(opportunity)
  ) as MultipleAvailableOpportunity[];

export const getAvailableOpportunities = (
  opportunities: (SingleOpportunity | MultipleOpportunity)[]
): (SingleAvailableOpportunity | MultipleAvailableOpportunity)[] =>
  opportunities.filter((opportunity: SingleOpportunity | MultipleOpportunity) =>
    getIsAvailableOpportunity(opportunity)
  ) as (SingleAvailableOpportunity | MultipleAvailableOpportunity)[];
